module.exports = __webpack_public_path__ + "img/Chivas_Regal_12_Ferrari_second_bg.a37e54e1.jpg";